// Hand-rolled bridge from specs/seeds/dashboard-v2/wizards/donor-create.yaml
// (CHG-1241 / ITER-3364). See campaign-create.ts header for rationale.

import type { WizardManifest } from "../../wizards/manifestTypes";

export const donorCreateManifest: WizardManifest = {
  wizard_id: "donor-create",
  version: "1.0.0",
  spec_id: "experience.cross-screen.donor-create-v2",
  title: "Add donor",
  subtitle: "Register a new donor in 2 steps.",
  shape: "modal-wizard",
  size: "md",
  persistence_key: "donor-create",
  trigger: {
    permission: "alora-giving.donor.create",
    invocation: [{ from_route: "/donors", button: "Add donor" }],
  },
  field_type_coverage: {
    canonical: ["email", "phone", "locale_picker", "country_picker", "designation_picker", "tag_input"],
    pending_primitive: ["text"],
    custom_renders: [],
  },
  steps: [
    {
      step_id: "identity",
      label: "Identity",
      description: "Who is this donor?",
      fields: [
        { name: "full_name", type: "text", label: "Full name", required: true, pending_primitive: true, props: { max_length: 255 } },
        { name: "email", type: "email", label: "Email" },
        { name: "phone", type: "phone", label: "Phone" },
        { name: "preferred_locale", type: "locale_picker", label: "Preferred locale" },
      ],
    },
    {
      step_id: "details",
      label: "Optional details",
      description: "Address, salutation, default designation, tags. Skip to save without these.",
      optional: true,
      fields: [
        { name: "address_line1", type: "text", label: "Address line 1", pending_primitive: true, props: { max_length: 255 } },
        { name: "address_line2", type: "text", label: "Address line 2", pending_primitive: true, props: { max_length: 255 } },
        { name: "city", type: "text", label: "City", pending_primitive: true, props: { max_length: 100 } },
        { name: "state_province", type: "text", label: "State / province", pending_primitive: true, props: { max_length: 100 } },
        { name: "postal_code", type: "text", label: "Postal code", pending_primitive: true, props: { max_length: 20 } },
        { name: "country", type: "country_picker", label: "Country" },
        { name: "salutation", type: "text", label: "Salutation", pending_primitive: true, props: { max_length: 32 } },
        { name: "primary_designation_id", type: "designation_picker", label: "Primary designation (optional)" },
        { name: "tags", type: "tag_input", label: "Tags" },
      ],
    },
  ],
  on_submit: {
    api_endpoint: "POST /donors",
    on_success: { redirect: "/donors/{response.id}" },
    on_error: { show_in_step: true },
  },
  validation: [
    { step_id: "identity", field: "full_name", rule: "not_empty" },
    { step_id: "identity", field: "full_name", rule: "max_length_255" },
    { step_id: "identity", field: "email", rule: "email_format_or_empty" },
    { step_id: "identity", field: "phone", rule: "e164_format_or_empty" },
    { step_id: "identity", rule: "at_least_one_of", fields: ["email", "phone"] },
  ],
};
